/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StatisticsEvent
 */
export interface StatisticsEvent {
    /**
     * 
     * @type {string}
     * @memberof StatisticsEvent
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof StatisticsEvent
     */
    tenant_id?: string;
    /**
     * 
     * @type {string}
     * @memberof StatisticsEvent
     */
    type?: StatisticsEventTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof StatisticsEvent
     */
    date?: number;
    /**
     * 
     * @type {string}
     * @memberof StatisticsEvent
     */
    user_id?: string;
    /**
     * 
     * @type {string}
     * @memberof StatisticsEvent
     */
    payload?: string;
}


/**
 * @export
 */
export const StatisticsEventTypeEnum = {
    Unsubscription: 'unsubscription',
    Subscription: 'subscription',
    UnsubscriptionPaymentFailed: 'unsubscription-payment_failed',
    AppointmentAttempt: 'appointment_attempt',
    SubscriptionRenewal: 'subscription-renewal',
    SubscriberCount: 'subscriber-count',
    Session: 'session',
    ClinicChange: 'clinic-change',
    PaidAppointment: 'paid-appointment',
    SubscriberCountClinic: 'subscriber-count-clinic',
    ReferralCodeUsed: 'referral-code-used',
    SesEmailStats: 'ses-email-stats',
    NotificationStats: 'notification-stats',
    SmsStats: 'sms-stats',
    Hl7Stats: 'hl7-stats',
    TenantHealthSnapshot: 'tenant-health-snapshot',
    CronRun: 'cron-run'
} as const;
export type StatisticsEventTypeEnum = typeof StatisticsEventTypeEnum[keyof typeof StatisticsEventTypeEnum];


/**
 * Check if a given object implements the StatisticsEvent interface.
 */
export function instanceOfStatisticsEvent(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StatisticsEventFromJSON(json: any): StatisticsEvent {
    return StatisticsEventFromJSONTyped(json, false);
}

export function StatisticsEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatisticsEvent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'tenant_id': !exists(json, 'tenant_id') ? undefined : json['tenant_id'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'date': !exists(json, 'date') ? undefined : json['date'],
        'user_id': !exists(json, 'user_id') ? undefined : json['user_id'],
        'payload': !exists(json, 'payload') ? undefined : json['payload'],
    };
}

export function StatisticsEventToJSON(value?: StatisticsEvent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'tenant_id': value.tenant_id,
        'type': value.type,
        'date': value.date,
        'user_id': value.user_id,
        'payload': value.payload,
    };
}

